const { getObjectValue } = require('@root/helpers');

module.exports = {
	ADD_NOTIFICATION(state, payload) {
		state.notifications.push(payload);
	},

	ADD_REQUEST(state, payload) {
		state.requests[payload.name] = payload.request;
	},

	REMOVE_NOTIFICATION(state, payload) {
		// console.log(state.notifications, payload);

		state.notifications.splice(payload, 1);

		// _.remove(state.notifications, (notification) => {
		// 	console.log(notification.id, payload.id);

		// 	return notification.id === payload.id;
		// });

		// state.notifications.push(payload);
	},

	REMOVE_ITEM(state, payload) {
		let name = payload.name;

		if (state && name.indexOf('.') && !state.hasOwnProperty(name)) {
			state = getObjectValue(name, state);
		}

		// if(typeof state !== 'array') {
		// 	console.error('The target must be an array not: ' + typeof state);
		// 	return;
		// }

		let index = _.findIndex(state, (item) => {
			return item[payload.key] === payload.value;
		});

		state.splice(index, 1);
	},

	REMOVE_REQUEST(state, payload) {
		delete state.requests[payload];
	},

	PUSH_ITEM(state, payload) {
		let name = payload.name;

		if (state && name.indexOf('.') && !state.hasOwnProperty(name)) {
			state = getObjectValue(name, state);
		}

		// console.log('state', state, payload);

		state.push(payload.value);
	},

	SET_VALUE(state, payload) {
		let name = payload.name;

		if (state && name.indexOf('.') && !state.hasOwnProperty(name)) {
			let namespace = name.slice(0, name.lastIndexOf('.'));
			name = name.slice(name.lastIndexOf('.') + 1);
			state = getObjectValue(namespace, state);
		}

		Vue.set(state, name, payload.value);
	},

	SET_HIDDEN_VALUE(state, payload) {
		let name = '';
		if(payload.hasOwnProperty('document_number')) {
			name = 'documents.documents';

			name += '.' + _.findIndex(getObjectValue(name, state), {number: payload.document_number}) + '.line_items'

			name += '.' + _.findIndex(getObjectValue(name, state), {id: payload.line_item_id}) + '.part.attributes'
 		} else {
			name = 'products.selectedProduct.attributes';
		}

		const attrIndex = _.findIndex(getObjectValue(name, state), {slug: payload.attribute_slug});

		Vue.set(getObjectValue(`${name}.${attrIndex}.field_configuration`, state), 'is_hidden', payload.is_hidden);
	},

	TOGGLE_PRIMARY_DRAWER(state) {
		state.primaryDrawer = !state.primaryDrawer;
	},

	TOGGLE_PROFILE_DRAWER(state) {
		state.profileDrawer = !state.profileDrawer;
	},

	UPDATE_USER(state, payload) {
		_.forIn(payload, (value, key) => {
			Vue.set(Spark.state.user, key, value);
		});
	},
};
